(() => {
  const root = document.querySelector('[data-quiz-section]');
  if (!root) {
    console.error('Quiz: Could not find [data-quiz-section]');
    return;
  }

  // Prevent double initialization
  if (root.dataset.quizInitialized) {
    console.log('Quiz: Already initialized, skipping');
    return;
  }
  root.dataset.quizInitialized = 'true';

  let config = {};
  try {
    const configEl = root.querySelector('[data-quiz-config]');
    console.log('Quiz config element:', configEl);
    console.log('Quiz config raw text:', configEl?.textContent?.substring(0, 500));
    if (configEl && configEl.textContent) {
      config = JSON.parse(configEl.textContent);
    }
    console.log('Quiz parsed config:', config);
  } catch (e) {
    console.error('Quiz: Failed to parse config JSON', e);
  }

  const body = root.querySelector('[data-quiz-body]');
  const backBtn = root.querySelector('[data-quiz-back]');
  const primaryBtn = root.querySelector('[data-quiz-primary]');
  const progressBar = root.querySelector('[data-quiz-progress]');

  if (!body || !primaryBtn) {
    console.error('Quiz: Missing required elements', { body, primaryBtn });
    return;
  }

  const state = {
    consent: null,
    firstName: '',
    goal: '',
    goalLabel: '',
    answers: {},
    email: '',
    marketingOptIn: true
  };

  const stack = [];

  const escapeHtml = (s) => String(s)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  // Goals from config (admin editable)
  const goals = config.goals || [];

  // Icons SVG library
  const primaryColor = config.primaryColor || '#4fab53';
  
  const icons = {
    bolt: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M13 2L4 14h7l-1 8 10-12h-8l1-8z" fill="${primaryColor}" stroke="${primaryColor}" stroke-width="1.5" stroke-linejoin="round"/>
      </svg>`,
    sparkle: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 2l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z" fill="${primaryColor}"/>
        <path d="M19 8l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z" fill="${primaryColor}" opacity="0.6"/>
      </svg>`,
    balance: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3v18" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M4 7h16" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M4 7l2 8h0a2 2 0 0 0 4 0h0l2-8M14 7l2 8h0a2 2 0 0 0 4 0h0l2-8" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="3" r="1.5" fill="${primaryColor}"/>
        <path d="M8 21h8" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
      </svg>`,
    shield: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 2l8 4v6c0 5-3.4 9.4-8 10-4.6-.6-8-5-8-10V6l8-4Z" fill="${primaryColor}" stroke="${primaryColor}" stroke-width="1.5"/>
        <path d="M9 12l2 2 4-5" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,
    gut: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7 4c-1.5 0-2.5 1.2-2.5 3s1 3 2.5 3c1 0 1.5.5 1.5 1.5v4c0 2.5 1.5 4.5 3.5 4.5" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M17 4c1.5 0 2.5 1.2 2.5 3s-1 3-2.5 3c-1 0-1.5.5-1.5 1.5" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M15.5 13c0 2.5-1 4.5-2.5 4.5" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M12 17.5c1.5 0 2.5 1.2 2.5 2.5" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
      </svg>`,
    meditation: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="5" r="2.5" fill="${primaryColor}"/>
        <path d="M12 8v4" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M8 11c-2 0-3 1-3 2.5S6 16 8 16h8c2 0 3-1 3-2.5S18 11 16 11" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M9 16v3c0 1 .5 2 1.5 2h3c1 0 1.5-1 1.5-2v-3" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
        <path d="M6 14H4M20 14h-2" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
      </svg>`,
    target: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="${primaryColor}" opacity="0.2"/>
        <circle cx="12" cy="12" r="6" fill="${primaryColor}" opacity="0.4"/>
        <circle cx="12" cy="12" r="2.5" fill="${primaryColor}"/>
      </svg>`,
    moon: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="${primaryColor}"/>
      </svg>`,
    heart: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="${primaryColor}"/>
      </svg>`,
    leaf: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 21c3-3 4-6 4-11 5 0 8 2 11 5-1 4-4 7-8 7-3 0-5-1-7-1z" fill="${primaryColor}"/>
        <path d="M6 21c2-2 3-4 3.5-6.5" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
      </svg>`,
    sun: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="5" fill="${primaryColor}"/>
        <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="${primaryColor}" stroke-width="2" stroke-linecap="round"/>
      </svg>`,
    brain: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 4.5c-1.5-1-3.5-1-5 0-2 1.5-2.5 4-1.5 6 .5 1 .5 2 0 3-.5 1.5 0 3 1 4s2.5 1.5 4 1c1-.5 2-.5 3 0 1.5.5 3 0 4-1s1.5-2.5 1-4c-.5-1-.5-2 0-3 1-2 .5-4.5-1.5-6-1.5-1-3.5-1-5 0z" fill="${primaryColor}"/>
        <path d="M12 4.5v14" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M8 8c0 2 1.5 3.5 4 3.5M16 8c0 2-1.5 3.5-4 3.5M8 14c0-1.5 1.5-2.5 4-2.5M16 14c0-1.5-1.5-2.5-4-2.5" stroke="#ffffff" stroke-width="1" stroke-linecap="round"/>
      </svg>`,
    flame: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 2c-3 4-6 6-6 11a6 6 0 0 0 12 0c0-5-3-7-6-11z" fill="${primaryColor}"/>
        <path d="M12 22c-2-2-3-4-3-6 0-2.5 1.5-4 3-6 1.5 2 3 3.5 3 6 0 2-1 4-3 6z" fill="#ffffff" opacity="0.4"/>
      </svg>`,
    drop: `
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 2c-3 4-7 8-7 12a7 7 0 0 0 14 0c0-4-4-8-7-12z" fill="${primaryColor}"/>
      </svg>`
  };

  // Questions from config (admin editable)
  const configQuestions = config.questions || [];

  console.log('Quiz config questions count:', configQuestions.length);
  console.log('Quiz config questions sample:', configQuestions.slice(0, 2));
  console.log('Quiz goals count:', goals.length);

  // Build goal-specific questions from config
  const goalQuestions = {};
  goals.forEach(goal => {
    const filtered = configQuestions.filter(q =>
      !q.forGoal || q.forGoal === '' || q.forGoal === goal.id
    );
    goalQuestions[goal.id] = filtered;
    console.log(`Questions for goal "${goal.id}":`, filtered.length, filtered);
  });

  // Generic questions (show for all goals if forGoal is blank)
  const genericQuestions = configQuestions.filter(q => !q.forGoal || q.forGoal === '');

  // ---------------------------
  // Screen Renderers
  // ---------------------------
  function renderWelcome() {
    return `
      <div class="quiz__screen quiz__screen--welcome" data-screen="welcome">
        <h2 class="quiz__title">${escapeHtml(config.welcomeTitle || 'Find Your Perfect Match')}</h2>
        <p class="quiz__subtitle">${escapeHtml(config.welcomeText || 'Answer a few quick questions and we\'ll recommend the best products for your wellness goals.')}</p>
      </div>`;
  }

  function renderConsent() {
    const privacyUrl = config.privacyPolicyUrl || '/policies/privacy-policy';
    return `
      <div class="quiz__screen quiz__screen--consent" data-screen="consent">
        <h2 class="quiz__title">${escapeHtml(config.consentTitle || 'Health Data')}</h2>
        <p class="quiz__subtitle">${escapeHtml(config.consentText || "Please note: We will ask you a series of questions relating to your health in order to determine which product we'd recommend. We never share this information with anyone outside of Ancient Extracts and we do not use the information for marketing or profiling reasons.")}</p>
        <p class="quiz__note"><a href="${escapeHtml(privacyUrl)}" target="_blank">${escapeHtml(config.consentPrivacyText || 'Read more on our Privacy Policy.')}</a></p>
        <p class="quiz__consent-agreement">${escapeHtml(config.consentAgreeText || 'To continue, you need to give explicit consent for Ancient Extracts to collect and process your health data, in accordance with our Privacy Policy')}</p>
        <div class="quiz__choices quiz__consent-choices">
          <label class="quiz__choice">
            <input type="radio" name="consent" value="agree" class="quiz__consent-input">
            <span class="quiz__pill"></span>
            <span class="quiz__choice-label">${escapeHtml(config.consentAgreeOption || 'I agree')}</span>
          </label>
          <label class="quiz__choice">
            <input type="radio" name="consent" value="disagree" class="quiz__consent-input">
            <span class="quiz__pill"></span>
            <span class="quiz__choice-label">${escapeHtml(config.consentDisagreeOption || 'I disagree')}</span>
          </label>
        </div>
      </div>`;
  }

  function renderName() {
    return `
      <div class="quiz__screen quiz__screen--name" data-screen="name">
        <p class="quiz__subtitle">${escapeHtml(config.nameSubtitle || "Let's get to know each other")}</p>
        <h2 class="quiz__title">${escapeHtml(config.nameTitle || "What's your first name?")}</h2>
        <div class="quiz__field quiz__name-field">
          <input type="text" class="quiz__input quiz__name-input" placeholder="${escapeHtml(config.namePlaceholder || 'Enter text')}" value="${escapeHtml(state.firstName)}">
        </div>
      </div>`;
  }

  function renderGoals() {
    const goalsHtml = goals.map(g => {
      const iconSvg = icons[g.icon] || icons.heart;
      return `
        <button type="button" class="quiz__tile" data-goal-id="${escapeHtml(g.id)}" data-goal-label="${escapeHtml(g.label)}">
          <span class="quiz__tile-icon">${iconSvg}</span>
          <span class="quiz__tile-label">${escapeHtml(g.label)}</span>
        </button>`;
    }).join('');

    return `
      <div class="quiz__screen quiz__screen--goals" data-screen="goals">
        <h2 class="quiz__title">${escapeHtml(config.goalScreenTitle || 'What area would you like to focus on?')}</h2>
        <p class="quiz__subtitle">${escapeHtml(config.goalScreenSubtitle || 'Select the wellness goal that matters most to you right now.')}</p>
        <div class="quiz__goals-grid">${goalsHtml}</div>
      </div>`;
  }

  function renderGoalIntro() {
    const goal = goals.find(g => g.id === state.goal);
    if (!goal) return renderGoals();
    
    return `
      <div class="quiz__screen quiz__screen--intro" data-screen="intro">
        <h2 class="quiz__title">${escapeHtml(goal.introTitle)}</h2>
        <p class="quiz__subtitle">${escapeHtml(goal.introText)}</p>
      </div>`;
  }

  function renderQuestion(q) {
    const isMulti = q.type === 'multi';
    const options = Array.isArray(q.options) ? q.options : [];

    const optionsHtml = options.map((opt) => {
      const optVal = String(opt).trim();
      if (!optVal) return '';
      return `
        <button type="button" class="quiz__answer-btn${isMulti ? ' quiz__answer-btn--multi' : ''}" data-value="${escapeHtml(optVal)}">
          ${escapeHtml(optVal)}
        </button>`;
    }).join('');

    return `
      <div class="quiz__screen quiz__screen--question" data-screen="question" data-question-id="${escapeHtml(q.id)}" data-question-type="${isMulti ? 'multi' : 'single'}">
        <h2 class="quiz__title">${escapeHtml(q.title)}</h2>
        ${q.subtitle ? `<p class="quiz__subtitle">${escapeHtml(q.subtitle)}</p>` : ''}
        <div class="quiz__answers">${optionsHtml}</div>
      </div>`;
  }

  function renderDone() {
    const goal = goals.find(g => g.id === state.goal);
    const products = goal?.products || [];
    
    let productsHtml = '';
    if (products.length > 0) {
      productsHtml = `
        <div class="quiz__products">
          ${products.map(p => `
            <a href="${escapeHtml(p.url)}" class="quiz__product">
              ${p.image ? `<img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.title)}" class="quiz__product-image">` : ''}
              <span class="quiz__product-title">${escapeHtml(p.title)}</span>
              <span class="quiz__product-price">${escapeHtml(p.price)}</span>
            </a>
          `).join('')}
        </div>`;
    }

    return `
      <div class="quiz__screen quiz__screen--done" data-screen="done">
        <h2 class="quiz__title">${escapeHtml(config.resultsTitle || 'Your Personalized Recommendations')}</h2>
        <p class="quiz__subtitle">${escapeHtml(config.resultsText || 'Based on your answers, here are the products we think would work best for you.')}</p>
        ${productsHtml}
      </div>`;
  }

  function renderEmail() {
    return `
      <div class="quiz__screen quiz__screen--email" data-screen="email">
        <p class="quiz__subtitle">${escapeHtml(config.emailSubtitle || "Almost there!")}</p>
        <h2 class="quiz__title">${escapeHtml(config.emailTitle || "Where should we send your results?")}</h2>
        <p class="quiz__note">${escapeHtml(config.emailNote || "We'll also send you personalised tips and exclusive offers.")}</p>
        <div class="quiz__field quiz__email-field">
          <input type="email" class="quiz__input quiz__email-input" placeholder="${escapeHtml(config.emailPlaceholder || 'Enter your email')}" value="${escapeHtml(state.email)}">
        </div>
        <label class="quiz__checkbox-label">
          <input type="checkbox" class="quiz__marketing-checkbox" ${state.marketingOptIn ? 'checked' : ''}>
          <span>${escapeHtml(config.marketingText || "I'd like to receive wellness tips and exclusive offers")}</span>
        </label>
      </div>`;
  }

  // Klaviyo integration
  async function submitToKlaviyo() {
    const klaviyo = window.klaviyo || window._klOnsite || [];

    // Prepare the data
    const quizData = {
      firstName: state.firstName,
      email: state.email,
      goal: state.goal,
      goalLabel: state.goalLabel,
      answers: state.answers,
      marketingOptIn: state.marketingOptIn,
      completedAt: new Date().toISOString()
    };

    console.log('Submitting to Klaviyo:', quizData);

    // Method 1: Klaviyo identify + track (if Klaviyo is loaded)
    if (typeof klaviyo !== 'undefined' && klaviyo.push) {
      // Identify the user
      klaviyo.push(['identify', {
        '$email': state.email,
        '$first_name': state.firstName,
        'Quiz Goal': state.goalLabel,
        'Quiz Goal ID': state.goal,
        'Quiz Completed': true,
        'Quiz Marketing Opt-In': state.marketingOptIn
      }]);

      // Track the quiz completion event
      klaviyo.push(['track', config.klaviyoEventName || 'Quiz Completed', {
        'Goal': state.goalLabel,
        'Goal ID': state.goal,
        'First Name': state.firstName,
        'Answers': JSON.stringify(state.answers),
        'Marketing Opt-In': state.marketingOptIn
      }]);

      console.log('Klaviyo events pushed');
    }

    // Method 2: Also submit via the hidden Shopify customer form as backup
    const customerForm = root.querySelector('.quiz__shopify-customer-form');
    if (customerForm && state.email) {
      const formData = new FormData(customerForm);
      formData.set('contact[email]', state.email);
      formData.set('contact[first_name]', state.firstName);
      formData.set('contact[tags]', `quiz, quiz-goal-${state.goal}`);
      formData.set('contact[accepts_marketing]', state.marketingOptIn ? 'true' : 'false');

      try {
        await fetch(customerForm.action || '/contact', {
          method: 'POST',
          body: formData
        });
        console.log('Shopify customer form submitted');
      } catch (e) {
        console.log('Shopify form submission note:', e.message);
      }
    }
  }

  console.log('goalQuestions object keys:', Object.keys(goalQuestions));
  console.log('goalQuestions object:', goalQuestions);

  // ---------------------------
  // Navigation Logic
  // ---------------------------
  function getQuestionList() {
    console.log('getQuestionList called with state.goal:', state.goal);
    console.log('goalQuestions[state.goal]:', goalQuestions[state.goal]);
    const goalQs = goalQuestions[state.goal] || [];
    return goalQs;
  }

  function getCurrentScreen() {
    return body.querySelector('[data-screen]')?.dataset.screen || 'welcome';
  }

  function getProgress() {
    const screen = getCurrentScreen();
    if (screen === 'welcome') return 0;
    if (screen === 'consent') return 5;
    if (screen === 'name') return 10;
    if (screen === 'goals') return 15;
    if (screen === 'intro') return 20;
    if (screen === 'email') return 95;
    if (screen === 'done') return 100;

    const questions = getQuestionList();
    const currentQId = body.querySelector('[data-question-id]')?.dataset.questionId;
    const idx = questions.findIndex(q => q.id === currentQId);
    if (idx === -1) return 30;

    const qProgress = 30 + ((idx + 1) / Math.max(questions.length, 1)) * 60;
    return Math.min(qProgress, 90);
  }

  function updateUI() {
    const screen = getCurrentScreen();

    // Progress bar
    progressBar.style.width = `${getProgress()}%`;

    // Back button
    backBtn.style.display = stack.length > 0 ? '' : 'none';

    // Primary button
    if (screen === 'welcome') {
      primaryBtn.textContent = config.startButtonText || 'Start now';
      primaryBtn.style.display = '';
      primaryBtn.disabled = false;
    } else if (screen === 'consent') {
      primaryBtn.textContent = config.continueButtonText || 'Continue';
      primaryBtn.style.display = 'none'; // Hidden until consent given
      primaryBtn.disabled = true;
    } else if (screen === 'name') {
      primaryBtn.textContent = config.nameSubmitText || 'Submit';
      primaryBtn.style.display = '';
      primaryBtn.disabled = !state.firstName.trim();
    } else if (screen === 'goals') {
      primaryBtn.style.display = 'none';
    } else if (screen === 'intro') {
      primaryBtn.textContent = config.continueButtonText || 'Continue';
      primaryBtn.style.display = '';
      primaryBtn.disabled = false;
    } else if (screen === 'question') {
      const questionType = body.querySelector('[data-question-type]')?.dataset.questionType;
      if (questionType === 'multi') {
        // Multi-select shows Continue button
        primaryBtn.textContent = config.continueButtonText || 'Continue';
        primaryBtn.style.display = '';
        const selected = body.querySelectorAll('.quiz__answer-btn--selected');
        primaryBtn.disabled = selected.length === 0;
      } else {
        // Single-select auto-advances, hide button
        primaryBtn.style.display = 'none';
      }
    } else if (screen === 'email') {
      primaryBtn.textContent = config.emailSubmitText || 'See My Results';
      primaryBtn.style.display = '';
      // Disable until valid email entered
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
      primaryBtn.disabled = !isValidEmail;
    } else if (screen === 'done') {
      primaryBtn.textContent = config.resultsButtonText || 'Shop Now';
      primaryBtn.style.display = '';
      primaryBtn.disabled = false;
    }
  }

  function hasValidAnswer() {
    const inputs = body.querySelectorAll('.quiz__input:checked');
    return inputs.length > 0;
  }

  function navigate(html, addToStack = true) {
    if (addToStack) {
      stack.push(body.innerHTML);
    }
    body.innerHTML = html;
    updateUI();
    bindScreenEvents();
  }

  function goBack() {
    if (stack.length === 0) return;
    body.innerHTML = stack.pop();
    updateUI();
    bindScreenEvents();
  }

  function bindScreenEvents() {
    const screen = getCurrentScreen();

    if (screen === 'consent') {
      body.querySelectorAll('.quiz__consent-input').forEach(input => {
        input.addEventListener('change', () => {
          const selected = body.querySelector('.quiz__consent-input:checked');
          if (selected && selected.value === 'agree') {
            state.consent = true;
            navigate(renderName());
          } else if (selected && selected.value === 'disagree') {
            state.consent = false;
            // Could show a message or redirect, for now just don't proceed
          }
        });
      });
    }

    if (screen === 'name') {
      const nameInput = body.querySelector('.quiz__name-input');
      if (nameInput) {
        nameInput.addEventListener('input', () => {
          state.firstName = nameInput.value;
          primaryBtn.disabled = !state.firstName.trim();
        });
        // Focus the input
        nameInput.focus();
      }
    }

    if (screen === 'goals') {
      body.querySelectorAll('[data-goal-id]').forEach(btn => {
        btn.addEventListener('click', () => {
          state.goal = btn.dataset.goalId;
          state.goalLabel = btn.dataset.goalLabel;
          navigate(renderGoalIntro());
        });
      });
    }

    if (screen === 'question') {
      const questionType = body.querySelector('[data-question-type]')?.dataset.questionType;
      const qId = body.querySelector('[data-question-id]')?.dataset.questionId;

      body.querySelectorAll('.quiz__answer-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          if (questionType === 'multi') {
            // Multi-select: toggle selection
            btn.classList.toggle('quiz__answer-btn--selected');
            // Update state
            const selected = body.querySelectorAll('.quiz__answer-btn--selected');
            state.answers[qId] = Array.from(selected).map(b => b.dataset.value);
            primaryBtn.disabled = selected.length === 0;
          } else {
            // Single select: save and auto-advance
            state.answers[qId] = [btn.dataset.value];
            // Brief visual feedback then advance
            btn.classList.add('quiz__answer-btn--selected');
            setTimeout(() => {
              const questions = getQuestionList();
              const idx = questions.findIndex(q => q.id === qId);
              if (idx < questions.length - 1) {
                navigate(renderQuestion(questions[idx + 1]));
              } else {
                // Last question - go to email capture
                navigate(renderEmail());
              }
            }, 200);
          }
        });
      });
    }

    if (screen === 'email') {
      const emailInput = body.querySelector('.quiz__email-input');
      const marketingCheckbox = body.querySelector('.quiz__marketing-checkbox');

      if (emailInput) {
        emailInput.addEventListener('input', () => {
          state.email = emailInput.value;
          // Basic email validation
          const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
          primaryBtn.disabled = !isValidEmail;
        });
        emailInput.focus();
      }

      if (marketingCheckbox) {
        marketingCheckbox.addEventListener('change', () => {
          state.marketingOptIn = marketingCheckbox.checked;
        });
      }
    }
  }

  function handlePrimary() {
    const screen = getCurrentScreen();
    console.log('handlePrimary called - current screen:', screen);
    console.log('handlePrimary - state.goal:', state.goal);

    if (screen === 'welcome') {
      navigate(renderConsent());
      return;
    }

    if (screen === 'name') {
      // Name submitted, go to goals
      navigate(renderGoals());
      return;
    }

    if (screen === 'intro') {
      const questions = getQuestionList();
      console.log('Intro screen - state.goal:', state.goal);
      console.log('Intro screen - questions for this goal:', questions.length, questions);
      if (questions.length > 0) {
        navigate(renderQuestion(questions[0]));
      } else {
        console.warn('No questions found for goal, going to done screen');
        navigate(renderDone());
      }
      return;
    }

    if (screen === 'question') {
      // Save answer (for multi-select via Continue button)
      const qId = body.querySelector('[data-question-id]')?.dataset.questionId;
      const selected = body.querySelectorAll('.quiz__answer-btn--selected');
      state.answers[qId] = Array.from(selected).map(b => b.dataset.value);

      // Next question or email capture
      const questions = getQuestionList();
      const idx = questions.findIndex(q => q.id === qId);

      if (idx < questions.length - 1) {
        navigate(renderQuestion(questions[idx + 1]));
      } else {
        navigate(renderEmail());
      }
      return;
    }

    if (screen === 'email') {
      // Submit to Klaviyo and show results
      submitToKlaviyo();
      navigate(renderDone());
      return;
    }

    if (screen === 'done') {
      // Navigate to results URL
      const url = config.resultsButtonUrl || '/collections/all';
      window.location.href = url;
      return;
    }
  }

  // ---------------------------
  // Initialize
  // ---------------------------
  body.innerHTML = renderWelcome();
  updateUI();
  bindScreenEvents();

  primaryBtn.addEventListener('click', handlePrimary);
  if (backBtn) {
    backBtn.addEventListener('click', goBack);
  }

  console.log('Quiz initialized successfully', { goals: goals.length, questions: configQuestions.length });
})();
